// Entity Management Permissions

export const ENTITIES_INDEX = 28;
export const ENTITIES_CREATE = 29;
export const ENTITIES_EDIT = 30;
export const ENTITIES_DELETE = 31;
export const ENTITIES_RESTORE = 1375;
// Quick-add is the same capability as create, with fewer fields.
export const ENTITIES_QUICK_CREATE = ENTITIES_CREATE;
